import { Suspense } from 'react';

export const LazySvg = (LazyComponent) => (props) => (
  <Suspense fallback={<div style={{ width: 24, height: 24 }} />}>
    <LazyComponent {...props} />
  </Suspense>
);